import produce from 'immer';

const INITIAL_STATE = {
  me: '',
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@auth/USER_DATA': {
        draft.me = action.payload.me;
        break;
      }
      default:
    }
  });
}
